// Croqui: `components/Tile.tsx` (Tile + IconTile).

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { Icon, type IconName } from './icon.tsx';
import { INK_TEXT, type Ink } from './ink.ts';

/** Quadrado elevado: avatar, número de seção, contêiner de ícone. O raio acompanha o tamanho. */
export function Tile({
  children,
  size = 40,
  radius,
  className,
}: {
  children?: ReactNode;
  size?: number;
  radius?: number;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'grid shrink-0 place-items-center border border-tile-border bg-tile',
        className,
      )}
      style={{
        width: size,
        height: size,
        borderRadius: radius ?? (size >= 40 ? 12 : size >= 32 ? 9 : 8),
      }}
    >
      {children}
    </div>
  );
}

/** Tile com um ícone pintado pela tinta: lançamento, card de taxa, pendência, vazio. */
export function IconTile({
  icon,
  size = 32,
  ink = 'muted',
  iconSize,
  className,
}: {
  icon: IconName;
  size?: number;
  ink?: Ink;
  iconSize?: number;
  className?: string;
}) {
  return (
    <Tile size={size} className={cn(INK_TEXT[ink], className)}>
      <Icon name={icon} size={iconSize ?? Math.round(size / 2)} />
    </Tile>
  );
}
